import { render, staticRenderFns } from "./DemonstrativoFrequencia.vue?vue&type=template&id=3cb48413&"
import script from "./DemonstrativoFrequencia.vue?vue&type=script&lang=js&"
export * from "./DemonstrativoFrequencia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports